import styled, { css } from 'styled-components';

export const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',

  '&[data-has-chip-minimizer="true"]': {
    width: '60%',
    paddingRight: '25rem',
  },
});

export const Title = styled.h3(({ theme }) => ({
  lineHeight: '1.5',
  wordWrap: 'break-word',
  color: theme.palette.artichoke,
  fontFamily: theme.typography.family.playfairDisplay,
  textTransform: 'uppercase',
  fontSize: theme.typography.size24,
  fontWeight: 500,
}));

export const InsideContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-around',
  height: '100%',
  width: '100%',
  marginTop: '20rem',

  '&.dimensions': {
    gap: '20rem',
    width: '100%',
    height: '140rem',
    marginTop: '0',

    '&.no-width': {
      marginTop: '3rem',
    },
  },

  '&.sink': {
    marginTop: '25rem',
  },
});

export const MainImage = styled.div({
  display: 'flex',
  justifyContent: 'center',
  width: '50%',
  position: 'relative',
});

export const TrendBadge = styled.div(({ theme }) => ({
  background: theme.defaultTheme.trendColor,
  color: theme.palette.white,
  fontSize: '12rem',
  padding: '0 10rem',
  position: 'absolute',
  top: '20rem',
}));

export const ModalDescription = styled.p(({ theme }) => ({
  fontSize: '16rem',
  fontFamily: theme.typography.family.arial,
}));

export const Description = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  width: '50%',
});

export const DiscountContainer = styled.div({
  display: 'flex',
  width: '100%',
});

export const PriceContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
});

export const PriceList = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignContent: 'center',
  borderBottom: `1rem solid ${theme.palette.erieBlack}`,
}));

export const PriceInfo = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
});

export const ItalicPriceLabel = styled.span({
  fontStyle: 'italic',
});

export const DiscountLabel = styled.span(({ theme }) => ({
  color: theme.palette.red,
}));

const sharedPriceValueStyle = css`
  font-size: ${({ theme }) => theme.typography.size16};
  font-family: ${({ theme }) => theme.typography.family.arial};
  letter-spacing: 0;
  color: ${({ theme }) => theme.palette.erieBlack};
`;

export const PriceValue = styled.span`
  ${sharedPriceValueStyle}
`;

export const DiscountPrice = styled.span`
  ${sharedPriceValueStyle}
  text-decoration: line-through;
`;

export const ImageContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});

export const ImageHeader = styled.p({
  fontWeight: 'bold',
});

export const TotalPrice = styled.span({
  textAlign: 'end',
});

export const TempImage = styled.img({
  width: '150rem',
  height: '140rem',
});

export const MiniatureMainImage = styled.img({
  width: '150rem',
});
